// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3urpA","colBig":"styles_colBig__x5mN6","colSmall":"styles_colSmall__1VoV2","shopifyNameWrapper":"styles_shopifyNameWrapper__3DOsJ"};